import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { PricingModal } from './PremiumFeatureGate';
import { normalizePricingContext } from '../utils/openPricingModal';

/**
 * Global Pricing Modal Handler
 * Renders independently of MainNavigation to avoid blocking from calculator re-mounts
 */
const GlobalPricingModal = () => {
  const [showPricing, setShowPricing] = useState(false);
  const [pricingContext, setPricingContext] = useState(null);

  useEffect(() => {
    console.log('🌍 GlobalPricingModal mounted and listening for events');

    const handleShowPricing = (event) => {
      console.log('🌍 GlobalPricingModal received showPricingModal event');
      setPricingContext(normalizePricingContext(event.detail || {}));
      setShowPricing(true);
    };

    window.addEventListener('showPricingModal', handleShowPricing);

    const params = new URLSearchParams(window.location.search);
    let urlTimer = null;
    if (params.get('open_pricing') === '1' || params.get('cta') === 'pricing') {
      const source = params.get('source') || 'url_pricing_link';
      const calculatorTier = params.get('calculator_tier') || params.get('calculator') || 'unknown';
      const surface = params.get('surface') || 'url_pricing';
      const pricingView = params.get('pricing_view') || 'simple';
      urlTimer = window.setTimeout(() => {
        setPricingContext(normalizePricingContext({ source, calculatorTier, surface, pricingView }));
        setShowPricing(true);
      }, 400);
    }

    return () => {
      console.log('🌍 GlobalPricingModal unmounting');
      window.removeEventListener('showPricingModal', handleShowPricing);
      if (urlTimer) window.clearTimeout(urlTimer);
    };
  }, []);

  useEffect(() => {
    console.log('🌍 GlobalPricingModal showPricing state:', showPricing);
  }, [showPricing]);

  if (!showPricing) {
    return null;
  }

  console.log('🌍 GlobalPricingModal rendering modal');
  
  return ReactDOM.createPortal(
    <PricingModal context={pricingContext} onClose={() => {
      console.log('🌍 GlobalPricingModal closing modal');
      setShowPricing(false);
      setPricingContext(null);
    }} />,
    document.body
  );
};

export default GlobalPricingModal;


